var Base = {
    init: function () {
        var self = this;

        this.updateLastInteraction();

        (function ($) {
                if ($('#exit-popup-comparison').length === 0) {
                    if (Device.isMobile()) {
                        if ($('#exit-popup-organic-mobile').length > 0) {
                            self.initExitPopupOrganicMobile();
                        } else {
                            self.initExitPopupMobile();
                        }
                    } else {
                        self.initExitPopup();
                    }
                }

                self.initQuickNav();
                self.initSticky();
                self.initDisclosure();
                self.initBottomBanner();

                jQuery(document).on('click', '[data-href]', function (e) {
                    var targetTag = jQuery(e.target).prop("tagName");
                    if (jQuery(e.target).hasClass('unbind-data-href') || ['INPUT', 'SELECT', 'TEXTAREA'].indexOf(targetTag) >= 0) {
                        return;
                    }

                    var href = jQuery(this).data('href'),
                        target = jQuery(this).data('target'),
                        rel = jQuery(this).data('rel');

                    if (target === 'blank') {
                        var a = jQuery('<a>').attr({
                            'href': href,
                            'target': '_blank',
                            'id': 'link_for_click'
                        });

                        if (typeof jQuery(this).data('ga-label') !== 'undefined') {
                            a.attr('data-ga-label', jQuery(this).data('ga-label'));
                        }

                        if (typeof jQuery(this).data('ga-prefix') !== 'undefined') {
                            a.attr('data-ga-prefix', jQuery(this).data('ga-prefix'));
                        }

                        if (typeof jQuery(this).data('ga-suffix') !== 'undefined') {
                            a.attr('data-ga-suffix', jQuery(this).data('ga-suffix'));
                        }

                        if (typeof jQuery(this).data('title') !== 'undefined') {
                            a.attr('title', jQuery(this).data('title'));
                        }

                        if (typeof jQuery(this).data('data-title') !== 'undefined') {
                            a.attr('data-title', jQuery(this).data('data-title'));
                        }

                        if (!rel) {
                            rel = 'nofollow';
                        }
                        a.attr('rel', rel);

                        jQuery(document.body).append(a);
                        jQuery('#link_for_click')[0].click();
                        jQuery('#link_for_click').remove();
                    } else {
                        window.location.href = href;
                    }
                });

                jQuery(document).on('click', '[data-href] a', function (e) {
                    e.stopPropagation();
                });

                // mobile menu toggler
                jQuery('#main_nav_toggler, #main_nav_close').on('click', function (e) {
                    e.preventDefault();
                    jQuery('.lang-curr-togglers .select-custom').removeClass('opened');
                    jQuery('#search_nav').removeClass('show');
                    jQuery('#main_nav').toggleClass('show');
                    jQuery('body:first').toggleClass('mobile-nav-active')
                });

                jQuery('.main-search-ctrl ').on('click', function (e) {
                    e.preventDefault();

                    jQuery('#main-search-holder').toggleClass('active');
                    jQuery('body').toggleClass('search-active');
                    jQuery('#main-search-holder input:first').focus();
                    mainSearch();
                });

                jQuery('#main-search-close').on('click', function (e) {
                    e.preventDefault();
                    jQuery('#main-search-holder').removeClass('active');
                    jQuery('body').removeClass('search-active');
                    Page.finishLoad('main-search-load');

                });

                var mainSearchTimeout = null;
                jQuery('#main-search-holder input:first').keyup(function (e) {

                    var isUpDown = false;
                    var $results = jQuery('#main-search-holder .results');
                    var selectedIndex = 0;

                    if ($results.find('.search-entry').length > 0) {
                        selectedIndex = $results.find('.selected').index();
                        switch (e.which) {
                            case 38: // up
                                selectedIndex--;
                                isUpDown = true;
                                break;

                            case 40: // down
                                selectedIndex++;
                                isUpDown = true;
                                break;

                            case 13: // enter
                                e.preventDefault();
                                $results.find('.selected').click();
                                break;
                        }
                    }

                    if (isUpDown) {
                        if (selectedIndex < 0) {
                            selectedIndex = $results.find('.search-entry').length - 1;
                        }

                        if (selectedIndex > ($results.find('.search-entry').length - 1)) {
                            selectedIndex = 0;
                        }


                        $results.find('.search-entry.selected').removeClass('selected');
                        $results.find('.search-entry:eq(' + selectedIndex + ')').addClass('selected');

                        if ($results.find('.search-entry.selected').length > 0) {
                            jQuery(this).val($results.find('.search-entry.selected').data('label'));
                        }
                    }

                    //do search
                    if (!isUpDown) {
                        clearTimeout(mainSearchTimeout);

                        mainSearchTimeout = setTimeout(function () {
                            mainSearch();
                        }, 500);

                        //navigate through results
                    } else {

                    }
                });

                var mainSearch = function () {
                    var data = {};
                    data['query'] = jQuery('#main-search-holder input:first').val();
                    data['action'] = 'main-search';
                    Page.finishLoad('main-search-load');
                    Page.startLoad('main-search-load', '#main-search-holder input');
                    jQuery.post(ajaxurl, data, function (results) {
                        jQuery('#main-search-holder .results').html(results);
                        jQuery('#main-search-holder .results .search-entry:first').addClass('selected');
                        window.starRating.init();
                        Page.finishLoad('main-search-load');

                    }, 'html');
                }

                jQuery('#search_nav_toggler').on('click', function (e) {
                    jQuery('.lang-curr-togglers .select-custom').removeClass('opened');
                    jQuery('#main_nav').removeClass('show');
                    jQuery('#search_nav').toggleClass('show');
                });

                //mobile submenu collapse
                jQuery('#main_nav').on('click', 'li.nav-item.dropdown a', function (e) {
                    if (Device.isTablet()) {
                        if (jQuery(this).next('ul.sub-menu').length > 0) {
                            e.preventDefault();
                        }

                        jQuery(this).parent('li').toggleClass('submenu-collapse');
                    }
                });

                jQuery(document).on('change', '.select-wrapper select', function () {
                    var $wrapper = jQuery(this).closest('.select-wrapper');
                    $wrapper.find('.selected').html(jQuery(this).find(':selected').text());
                });

                jQuery('.select-wrapper select').change();

                jQuery('#wp-admin-bar-toggle-force-tr-usage-log').on('click', function (e) {
                    e.preventDefault();

                    if (typeof jQuery.cookie('force-tr-usage-log') === 'undefined') {
                        jQuery.cookie('force-tr-usage-log', 1);
                    } else {
                        jQuery.removeCookie('force-tr-usage-log');
                    }

                    window.location.reload();
                });

                jQuery(document).on('click', 'label.custom-checkbox', function () {
                    var el = jQuery(this).find('input[type="checkbox"]');

                    if (!el.prop('disabled')) {
                        el.prop("checked", !el.prop("checked"));
                        jQuery(this).toggleClass('checked', el.prop("checked"));
                    }
                });

                jQuery(document).on('click', '.toggle-show-more', function (e) {
                    e.preventDefault();

                    var $content = jQuery(this).closest('.toggle-content');

                    jQuery(this).addClass("hidden");
                    $content.find('.toggle-show-less').removeClass("hidden");
                    $content.find('.toggle-dots').addClass("hidden");
                    $content.find('.toggle-full-content').removeClass("hidden");

                }).on('click', '.toggle-show-less', function (e) {
                    e.preventDefault();

                    var $content = jQuery(this).closest('.toggle-content');

                    jQuery(this).addClass("hidden");

                    $content.find('.toggle-show-more').removeClass("hidden");
                    $content.find('.toggle-dots').removeClass("hidden");
                    $content.find('.toggle-full-content').addClass("hidden");

                });

                self.customSelectInit();

                //colorbox hooks
                jQuery(document).on('click', '.popup-close', function (e) {
                    e.preventDefault();

                    jQuery.colorbox.close();
                });

                jQuery(document).on('click', '[data-toggle="colorbox"]', function (e) {
                    e.preventDefault();

                    var target = jQuery(this).attr('data-target');

                    if (typeof target !== 'undefined' && target.length && jQuery(target).length) {
                        Template.popup(target);
                    }
                });

                if (jQuery('[data-bf-countdown]').length > 0) {
                    self.startCountdown();
                }
            }
        )
        (jQuery);

        this.initZPatternDisappearingTooltips();
    },

    initQuickNav: function () {
        var self = this;

        var $quickNav = jQuery('#quick-nav');
        if ($quickNav.length === 0) {
            return;
        }

        var $quickNavItems = $quickNav.find('a');

        jQuery(window).scroll(function (e) {
            $quickNavItems.each(function () {
                var id = jQuery(this).attr('href');
                var $section = jQuery(id);

                if ($section.length > 0) {
                    var top = $section.get(0).getBoundingClientRect().top;

                    if (top > -10 && top < 200) {
                        $quickNav.find('a').removeClass('active');
                        jQuery(this).addClass('active');
                        return false;
                    }
                }
            });
        });

        jQuery(window).scroll();
    },


    customSelectInit: function () {
        /*Triggers custom change event. Use jQuery('.select-custom').on('change', function (e, value) {}); to catch */
        jQuery(document).on('click', '.select-custom .selected', function () {
            jQuery(this).closest('.select-custom').toggleClass('opened');
        });

        jQuery(document).on('click', '.select-custom .options .option', function (e) {
            if (jQuery(this).attr('href') === '#') {
                e.preventDefault();
            }
            var title = jQuery(this).html(),
                value = jQuery(this).attr('data-value'),
                select = jQuery(this).closest('.select-custom'),
                inp = select.find('input');

            select.find('.selected').html(title);

            if (inp.length) {
                inp.val(value);
            }

            select.removeClass('opened');

            select.trigger("change", [value]);
        });
    },
    companiesSearch: function (selector) {

        // companies search autocomplete
        VendorsSearch.init({
            inputSelector: selector,
            autoSelect: true,
            companyIdInpSelector: '.company-id',
            resultsHolderClass: 'header-search-result',
            moreResultsLink: true,
            resultLimit: 7,
            selectFunction: function (event, ui) {
                if (ui.item && typeof ui.item.href !== 'undefined') {
                    location.href = ui.item.href;
                }
            },
            customOutput: function (ul, item) {
                var $link = jQuery('<a/>').attr({
                    'title': item.label
                });
                if (typeof item.href === 'undefined') {
                    $link.attr('href', 'javascript: void(0);');
                } else {
                    $link.attr('href', item.href);
                }
                $link.html('<span class="title">' + item.label + '</span>');
                if (item.recommend !== undefined /* item.recommend > 0 || item.not_recommend > 0*/) {
                    var $recommend = '<span class="like-unlike-holder"><span class="red-hand">' + item.not_recommend + '</span><span class="green-hand">' + item.recommend + '</span></span>';
                    $link.append($recommend);
                }
                return $link;
            }
        });
        jQuery(".companies-search-form").on('submit', function (e) {
            e.preventDefault();
            jQuery(this).find('.big-input').autocomplete("search");
        });

    },
    stickyEnabled: false,
    initSticky: function () {
        var self = this;

        if (jQuery('.sidebar .sticky').length === 0) {
            return;
        }

        if (Device.isScreen()) {
            jQuery('.sidebar .sticky').each(function () {
                jQuery(this).stick_in_parent()
                    .on('sticky_kit:bottom', function (e) {
                        jQuery(this).parent().css('position', 'absolute');
                    });
            });
            self.stickyEnabled = true;
        }
        jQuery(window).resize(function () {
            if (!Device.isScreen()) {
                jQuery('.sidebar .sticky').each(function () {
                    jQuery(this).trigger("sticky_kit:detach");
                });
                self.stickyEnabled = false;
            } else if (!self.stickyEnabled) {
                jQuery('.sidebar .sticky').each(function () {
                    jQuery(this).stick_in_parent().on('sticky_kit:bottom', function (e) {
                        jQuery(this).parent().css('position', 'absolute');
                    });
                });
                self.stickyEnabled = true;
            }
        });

        let topOffset = jQuery('.vendor-category-page-top').height();
        let footerHeight = jQuery('.site-footer').height();

        if (jQuery('.ppc-podium-container')[0]) {
            topOffset += 26;
            footerHeight += 40;
        }

        jQuery('.sidebar-main').css('top', topOffset + 'px');
        jQuery('.sidebar-main').css('height', 'calc(100% - ' + (footerHeight + 95 - topOffset) + 'px)');
    },

    startCountdown: function () {
        var x = setInterval(function () {

            jQuery('.countdown[data-time-left]:first').each(function () {
                var distance = jQuery(this).data('time-left') - 1;

                if (distance < 1) {
                    clearInterval(x);
                }

                jQuery(this).data('time-left', distance);

                var days = Math.floor(distance / (60 * 60 * 24)).toString();
                var hours = Math.floor((distance % (60 * 60 * 24)) / (60 * 60)).toString();
                var minutes = Math.floor((distance % (60 * 60)) / (60)).toString();
                var seconds = Math.floor((distance % 60)).toString();

                if (days.length < 2) {
                    days = '0' + days;
                }

                if (hours.length < 2) {
                    hours = '0' + hours;
                }

                if (minutes.length < 2) {
                    minutes = '0' + minutes;
                }

                if (seconds.length < 2) {
                    seconds = '0' + seconds;
                }

                jQuery('[data-bf-countdown]').each(function () {
                    switch (jQuery(this).data('bf-countdown')) {
                        case 'days':
                            jQuery(this).text(days);
                            break;
                        case 'hours':
                            jQuery(this).text(hours);
                            break;
                        case 'minutes':
                            jQuery(this).text(minutes);
                            break;
                        case 'seconds':
                            jQuery(this).text(seconds);
                            break;
                    }

                });
            });
        }, 1000);

        setTimeout(function () {
            jQuery('.countdown').css({opacity: 1});
        }, 1000);

    },

    lastInteraction: null,
    secondInterval: null,
    isPopUpOpened: false,

    initExitPopup: function () {
        var $exitPopup = $('#exit-popup');
        let forceExitIntent = (typeof window.location.hash !== "undefined" && window.location.hash === "#force-exit-intent" ? true : false);

        if ($exitPopup.length > 0) {
            if (typeof ouibounce !== 'undefined') {
                ouibounce($exitPopup.get(0), {
                    aggressive: forceExitIntent,
                    sitewide: true,
                    cookieDomain: '.' + window.location.host,
                    timer: forceExitIntent ? 0 : 1500,
                    delay: forceExitIntent ? 0 : 500,
                    cookieExpire: 30,
                    cookieName: (forceExitIntent ? null : '_exit_ppc_pp'),
                    callback: function () {
                        Base.showExitPopUp('#exit-popup');
                    }
                });
            }

            this.exitPopUpAfter();
        }
    },

    initExitPopupMobile: function () {
        var $exitPopup = $('#exit-popup');

        if ($exitPopup.length > 0) {
            if (typeof jQuery.cookie('_exit_ppc_pp') === 'undefined' || jQuery.cookie('_exit_ppc_pp') !== 'true') {

                this.secondInterval = setInterval(function () {
                    var currentTime = (new Date()).getTime();
                    var delta = 8000;

                    if (Base.lastInteraction + delta < currentTime) {
                        clearInterval(Base.secondInterval);

                        Base.showExitPopUp('#exit-popup');
                    }
                }, 1000);

                jQuery(document).on('scroll', function () {
                    if (Base.isPopUpOpened) {
                        return;
                    }

                    Base.updateLastInteraction();

                    //var showFrom = jQuery('.best-kit-block.single-vendor').offset().top + jQuery('.best-kit-block.single-vendor').outerHeight() - 60;
                    let scrollTop = jQuery(document).scrollTop();

                    let scrollToItem = 5;

                    if (jQuery('.single-vendor').length < scrollToItem) {
                        scrollToItem = jQuery('.single-vendor').length;
                    }

                    const vendorItem = jQuery('.single-vendor:nth-child(' + scrollToItem + ')');
                    if (vendorItem.length) {
                        const showFrom = vendorItem.offset().top - vendorItem.outerHeight();

                        if (showFrom < scrollTop) {
                            clearInterval(Base.secondInterval);

                            Base.showExitPopUp('#exit-popup');
                        }
                    }
                });

                jQuery(document).on('click', function () {
                    Base.updateLastInteraction();
                });
            }

            this.exitPopUpAfter();
        }
    },

    initExitPopupOrganicMobile: function () {
        var $exitPopup = $('#exit-popup-organic-mobile');

        if ($exitPopup.length > 0) {
            if (typeof jQuery.cookie('_exit_ppc_pp') === 'undefined' || jQuery.cookie('_exit_ppc_pp') !== 'true') {

                if ($exitPopup.data('className').indexOf('abt2') !== -1) {
                    setTimeout(() => {
                        if (!this.isPopUpOpened) {
                            this.showExitPopUp('#exit-popup-organic-mobile');
                        }
                    }, 20000);
                }

                this.secondInterval = setInterval(function () {
                    var currentTime = (new Date()).getTime();
                    var delta = 15000;

                    if (Base.lastInteraction + delta < currentTime) {
                        clearInterval(Base.secondInterval);

                        if (!Base.isPopUpOpened) {
                            Base.showExitPopUp('#exit-popup-organic-mobile');
                        }
                    }
                }, 1000);

                jQuery(document).on('click', function () {
                    Base.updateLastInteraction();
                });

                window.addEventListener('scroll', function () {
                    if (Base.isPopUpOpened) {
                        return false;
                    }

                    if ($(document).height() / 2 < window.pageYOffset) {
                        Base.showExitPopUp('#exit-popup-organic-mobile');
                    }

                }, {passive: true});

                // Trigger: user starts to scroll up very fast
                var topYOffset = 0;
                var scrollTopFastInterval = setInterval(function () {
                    if (Base.isPopUpOpened) {
                        clearInterval(scrollTopFastInterval);
                        return;
                    }

                    if (window.pageYOffset > 300 && topYOffset > window.pageYOffset && topYOffset - 800 > window.pageYOffset) {
                        Base.showExitPopUp('#exit-popup-organic-mobile');
                        return;
                    }

                    topYOffset = window.pageYOffset;
                }, 400);
            }

            this.exitPopUpAfter();
        }
    },

    showExitPopUp: function (id, params = {}) {
        Base.isPopUpOpened = true;
        jQuery.cookie('_exit_ppc_pp', true);

        const $exitPopup = $(id);

        let images = jQuery(id + ' .lazy');
        if (images) {
            images.each(function (i, item) {
                item = jQuery(item);
                item.removeClass('lazy');
                item.attr('src', item.data('src'));
            });
        }

        let options = {
            'onComplete': function () {
                jQuery('#colorbox').find('img').on('load', function () {
                    jQuery.colorbox.resize();
                });
            }
        };

        if (Device.isMobile()) {
            options.width = (window.screen.width - 30) + 'px';
        } else {
            if (this.isTemplate('start')) {
                options.width = '438px';
            } else {
                options.width = '430px';
            }

            if ($exitPopup.data('widthDesktop')) {
                options.width = $exitPopup.data('widthDesktop');
            }
        }

        if (id === '#exit-popup-organic-mobile' ||
            (Device.isMobile() && $exitPopup.data('bottomMobile') === 1)
        ) {
            options.opacity = '0.001';
            options.bottom = '0px';
            options.width = '100%';
        }

        GAEvents.sendEvent('exit popup', 'impression - ' + GAEvents.getPageName(window.location.href), $exitPopup.data('vendor'), true);

        if (typeof $exitPopup.attr('data-class-name') !== 'undefined') {
            options['className'] = $exitPopup.attr('data-class-name');
        }

        if (typeof aloomaPageData !== 'undefined' && typeof aloomaSendEvent !== 'undefined') {
            let aloomaData = aloomaPageData;

            if (typeof $exitPopup.attr("data-name") !== "undefined" && $exitPopup.attr("data-name") !== "") {
                aloomaData.pop_name = $exitPopup.attr("data-name");
            }

            let vendor_id = $exitPopup.find('#cboxInnerContent').data("vendor-id");

            if (vendor_id) {
                aloomaData.vendor_id = vendor_id;
            }

            aloomaSendEvent("exit_intent_fired", aloomaData);
        }

        Template.popup(id, undefined, Object.assign(options, params));

        setTimeout(jQuery.colorbox.resize, 100);
    },

    exitPopUpAfter: function () {
        jQuery(document).on('click', '.ppc-exit-popup #cboxClose, .ppc-exit-popup-countdown #cboxClose', function () {
            var label = jQuery(this).closest('#colorbox').find('#cboxInnerContent').data('ga-label');

            if (typeof label !== 'undefined' && label.length) {
                var pageName = GAEvents.getPageName(window.location.href);
                GAEvents.sendEvent('click in', 'X: close <– ' + pageName + ' (exit-popup)', label);
            }
        });

        jQuery(document).on('click', function (e) {
            var colorbox = jQuery(e.target).closest('.ppc-exit-popup');

            if (typeof colorbox === 'undefined') {
                colorbox = jQuery(e.target).closest('.ppc-exit-popup-countdown');
            }

            if (typeof colorbox !== 'undefined' && colorbox.length) {
                jQuery.colorbox.close();
            }
        });
    },

    updateLastInteraction: function () {
        this.lastInteraction = (new Date()).getTime();
    },

    initDisclosure: function () {
        jQuery(document).on('click', '.disclosure-trigger', function (e) {
            e.preventDefault();

            var container = jQuery(this).parent('.main-disclosure');
            if (typeof container === 'undefined' || container.length === 0) {
                container = jQuery(this).parent('.main-disclaimer');
            }

            if (typeof container !== 'undefined' && container.length) {
                container.toggleClass('active');

                if (Device.breakpoint('non-mobile') && container.hasClass('active')) {
                    const contentBlock = container.find('.disclosure-content');
                    if (contentBlock) {
                        contentBlock.css('top', this.offsetTop + 24 + 'px');

                        let left = this.offsetLeft - 106;

                        const containerHolder = container.parent('.top-disclaimer');
                        if (containerHolder && containerHolder.hasClass('abt')) {
                            left -= 34;
                        }

                        if (left + 350 < window.innerWidth) {
                            contentBlock.css('left', left + 'px');
                        } else {
                            contentBlock.css('right', '0px');
                        }
                    }
                }
            }
        });

        jQuery(document).on('click', function (e) {
            var target = jQuery(e.target);

            if (!target.hasClass('disclosure-trigger') && !target.hasClass('disclosure-content')) {
                jQuery('.main-disclosure').removeClass('active');
                jQuery('.main-disclaimer').removeClass('active');
            }
        });
    },

    emulateLink: function (href, clickedElement) {
        if (typeof href === 'undefined' || !href.length) {
            href = clickedElement.data('href');
        }

        if (!href) {
            return;
        }

        var target = clickedElement.data('target');

        if (target === 'blank') {
            var a = $('<a>').attr({
                'href': href,
                'target': '_blank',
                'rel': 'nofollow',
                'id': 'link_for_click'
            });

            if (typeof clickedElement.data('ga-event') !== 'undefined') {
                a.attr('data-ga-event', clickedElement.data('ga-event'));
            }

            if (typeof clickedElement.data('ga-label') !== 'undefined') {
                a.attr('data-ga-label', clickedElement.data('ga-label'));
            }

            if (typeof clickedElement.data('ga-prefix') !== 'undefined') {
                a.attr('data-ga-prefix', clickedElement.data('ga-prefix'));
            }

            if (typeof clickedElement.data('ga-suffix') !== 'undefined') {
                a.attr('data-ga-suffix', clickedElement.data('ga-suffix'));
            }

            if (typeof clickedElement.data('title') !== 'undefined') {
                a.attr('title', clickedElement.data('title'));
            }

            if (typeof clickedElement.data('data-title') !== 'undefined') {
                a.attr('data-title', clickedElement.data('data-title'));
            }

            $(document.body).append(a);
            $('#link_for_click')[0].click();
            $('#link_for_click').remove();
        } else {
            window.location.href = href;
        }
    },

    initBottomBanner: function () {
        var interval = setInterval(function () {
            jQuery('.countdown[data-time-left]:first').each(function () {
                var distance = jQuery(this).data('time-left') - 1;

                if (distance < 1) {
                    clearInterval(interval);
                }

                jQuery(this).data('time-left', distance);

                var days = Math.floor(distance / (60 * 60 * 24)).toString(),
                    hours = Math.floor((distance % (60 * 60 * 24)) / (60 * 60)).toString(),
                    minutes = Math.floor((distance % (60 * 60)) / (60)).toString(),
                    seconds = Math.floor((distance % 60)).toString();

                if (days.length < 2) {
                    days = '0' + days;
                }

                if (hours.length < 2) {
                    hours = '0' + hours;
                }

                if (minutes.length < 2) {
                    minutes = '0' + minutes;
                }

                if (seconds.length < 2) {
                    seconds = '0' + seconds;
                }

                jQuery('[data-bf-countdown]').each(function () {
                    switch (jQuery(this).data('bf-countdown')) {
                        case 'days':
                            jQuery(this).text(days);
                            break;
                        case 'hours':
                            jQuery(this).text(hours);
                            break;
                        case 'minutes':
                            jQuery(this).text(minutes);
                            break;
                        case 'seconds':
                            jQuery(this).text(seconds);
                            break;
                    }

                });
            });
        }, 1000);

        setTimeout(function () {
            jQuery('.countdown').css({opacity: 1});
        }, 1000);
    },

    isTemplate(template) {
        return window.location.pathname.indexOf('/' + template + '/') === 0;
    },

    isInViewport: function (element) {
        const rect = element.getBoundingClientRect();
        return (
            rect.top >= 0 &&
            rect.left >= 0 &&
            rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
            rect.right <= (window.innerWidth || document.documentElement.clientWidth)
        );
    },

    disappearingTooltips: {},
    showTooltip: function (target, delay = null) {
        const $tooltipElement = jQuery(target.parentElement.querySelector('.zp-disappearing-tooltip'));
        if (!$tooltipElement) {
            return;
        }

        const id = $tooltipElement.data('tooltipId');
        if (!id || $tooltipElement.hasClass('visible')) {
            return;
        }

        if (this.disappearingTooltips[id] === undefined) {
            this.disappearingTooltips[id] = 0;
        }

        if (this.disappearingTooltips[id] >= 2) {
            return;
        }

        if (delay) {
            setTimeout(() => {
                if (this.isInViewport($tooltipElement.get(0))) {
                    $tooltipElement.addClass('visible');
                    this.disappearingTooltips[id]++;
                }
            }, delay);
        } else {
            $tooltipElement.addClass('visible');
            this.disappearingTooltips[id]++;
        }

        setTimeout(() => {
            $tooltipElement.removeClass('visible');
        }, 1800);
    },

    initZPatternDisappearingTooltips: function () {
        const tooltips = jQuery('.zp-disappearing-tooltip');
        if (!tooltips.length) {
            return;
        }

        const observerCallback = (entries) => {
            for (const entry of entries) {
                if (entry.isIntersecting) {
                    this.showTooltip(entry.target, 250);
                }
            }
        };
        const observer = new IntersectionObserver(observerCallback, {
            root: null,
            threshold: 1.0,
        });

        jQuery('.zpattern-shortcode .btn-visit').each((i, element) => {
            if (Device.isMobile()) {
                observer.observe(element);
            } else {
                element.addEventListener('mouseover', (event) => {
                    this.showTooltip(event.target);
                });
            }
        });
    }
};

Base.init();
Base.companiesSearch('#header-search-input');
